<template>
	<div class="report-cls">
		<el-tabs v-model="activeName">
			<el-tab-pane label="待审核" name="first">
				<Unknown v-if="activeName === 'first'" />
			</el-tab-pane>
			<el-tab-pane label="已审核" name="second">
				<Audited v-if="activeName === 'second'" />
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import Unknown from './unknown';
import Audited from './audited';

export default {
	components: {Unknown, Audited},
	data() {
		return {
			activeName: 'first',
		}
	},
	watch: {
		$route: {
			handler(val){
				if(val?.query?.activeName) {
					this.activeName = this.$route?.query?.activeName;
				} 
			},
			immediate: true,
			deep: true
		}
	},
}
</script>

<style lang="scss" scoped>
.report-cls {
	width: 100%;
	padding: 20px;
	box-sizing: border-box;
}
</style>